// react-slick marks off-screen and cloned slides aria-hidden="true", but their links stay in the tab
// order, so keyboard users tab into slides they cannot see (Lighthouse "aria-hidden-focus").
// This takes focusable elements in hidden slides out of the tab order and restores them when the
// slide becomes visible. One observer covers every slider on the page.
const FOCUSABLE = "a[href], button, input, select, textarea, [tabindex]";
const MARK = "data-slick-tabindex"; // the tabindex the element had before, "" when it had none

function update(slide) {
    const hidden = slide.getAttribute("aria-hidden") === "true";
    slide.querySelectorAll(FOCUSABLE).forEach(element => {
        if (hidden && !element.hasAttribute(MARK)) {
            element.setAttribute(MARK, element.getAttribute("tabindex") ?? "");
            element.setAttribute("tabindex", "-1");
        } else if (!hidden && element.hasAttribute(MARK)) {
            const previous = element.getAttribute(MARK);
            if (previous === "") element.removeAttribute("tabindex");
            else element.setAttribute("tabindex", previous);
            element.removeAttribute(MARK);
        }
    });
}

export function watchSlickHiddenFocus(root = document.body) {
    const updateAll = () => root.querySelectorAll(".slick-slide").forEach(update);
    let scheduled = false;
    const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
            scheduled = false;
            updateAll();
        });
    });
    observer.observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ["aria-hidden"]});
    updateAll();
    return () => observer.disconnect();
}
